const pageShippingConditions = () => {
  // Page Load
  if (document.readyState === "complete" || document.readyState === "interactive") {
    scrollToAnchor();
  } else {
    document.addEventListener("DOMContentLoaded", scrollToAnchor);
    window.addEventListener("load", scrollToAnchor);
  }
  window.addEventListener("popstate", scrollToAnchor);
  window.addEventListener("hashchange", scrollToAnchor);

  // Menu Link Click
  const menulinks = document.querySelectorAll(".site-nav__menu__link");
  if (menulinks.length > 0) {
    menulinks.forEach((link) => {
      link.addEventListener("click", () => {
        scrollToAnchor();
      });
    });
  }

  // Footer Link Click
  const footerlinks = document.querySelectorAll(".footer .col-list-link");
  if (footerlinks.length > 0) {
    footerlinks.forEach((link) => {
      link.addEventListener("click", () => {
        scrollToAnchor();
      });
    });
  }
};

export default pageShippingConditions;

/**
 * Scroll to anchor
 */

const scrollToAnchor = () => {
  setTimeout(() => {
    let hash = window.location.hash;
    if (hash) {
      let element = document.querySelector(hash);
      if (element) {
        let offsetPosition = element.getBoundingClientRect().top + window.scrollY - 140;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  }, 800);
};
